import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

export const faObservedGrowthStageIcon = faCheckCircle;
